import PropertyValue from '@/components/Typography/PropertyValue';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const SurveyField = (
  props: CommonFieldProps & {
    value?: string;
  },
) => {
  const sources = useFeedbackSourceStore((state) => state.sourceInfo);
  const surveyName = sources
    ?.find((source) => source.source === SOURCE_TYPE.KNOCOMMERCE)
    ?.surveys?.find((survey) => survey.id === props.value)?.name;

  if (!props.showFull && !surveyName) return null;

  return (
    <PropertyRowWrapper {...props}>
      <PropertyValue value={surveyName} />
    </PropertyRowWrapper>
  );
};
